import type {
  ICompanyMSDocument,
  ICompanyMSUploadDocument,
} from './../types/document/models'
import { makeDocumentService } from '~/cynqueModules/factoriesForServices/documents'

export const {
  createDocument: createCompanyMSDocument,
  updateDocument: updateCompanyMSDocument,
  deleteDocument: deleteCompanyMSDocument,
} = makeDocumentService<ICompanyMSDocument, ICompanyMSUploadDocument>(
  '/api/companymsdocuments',
  'companyMSDocument'
)
